export enum InvoiceMode {
  SINGLE_INVOICE = 'single_invoice',
  MILESTONE_INVOICING = 'milestone_invoicing',
  NO_INVOICE = 'no_invoice'
}

export type InvoiceModeValue = InvoiceMode | null
export type InvoiceModeDisplay = 'Single Invoice' | 'Milestone Invoices' | 'No Invoice' | null

// Helper function to get display name from InvoiceMode
export const getInvoiceModeDisplay = (mode: InvoiceModeValue): InvoiceModeDisplay => {
  switch (mode) {
    case InvoiceMode.SINGLE_INVOICE:
      return 'Single Invoice'
    case InvoiceMode.MILESTONE_INVOICING:
      return 'Milestone Invoices'
    case InvoiceMode.NO_INVOICE:
      return 'No Invoice'
    default:
      return null
  }
}
